/**
 * A method that converts the length of a base64 tape to kilobytes
 * @param {val} @type {number} - length of the tape that must be converted to kilobytes
 * The algorithm was taken from this link:
 * https://stackoverflow.com/questions/53228948/how-to-get-image-file-size-from-base-64-string-in-javascript
 */
export default function convertBase64LengthToKb(val) {
  return Math.round((val - 3 / 4 - 2) / 1024);
}
